<template>
    <div class="my-timer-box">
        <template v-if="isBefore(endTime)">
            <div class="timer-title">{{timeText}}</div>
            <div class="time-con">
                <span class="timer-num" v-if="timeStatus">
                    {{leftSeconds}}
                </span> 
            </div>            
        </template>
        <div v-else class="time-con">
           <span class="timer-num">活动已结束</span> 
        </div> 
        <div>（截止时间 {{endDate}}）</div>
    </div>
</template>
<script>
    import {mapState, mapGetters, mapActions } from 'vuex'
    import {time2text} from '../../utils/base'
    import { WZ } from '../../common/globals'
    export default {        
        computed: {
            ...mapState('config', ['endTime']),
            ...mapState(['timeStatus','timeText']),
            ...mapGetters('timer', ['isBefore', 'isAfter', 'now', 'leftSecs','leftFor']),            
            leftSeconds() {
                return this.leftFor(this.endTime)
            },
            endDate(){
                if(this.endTime){
                    return time2text(this.endTime, 'YYYY-MM-DD hh:mm:ss')
                }
                return ''
            }
        },
    }
</script>